/**
 * Post-submit redirect logic (REQ-CHK-7/8; research/05 §2.6-2.7). Verbatim
 * from v1 checkout_helper.js: new flow → immediate redirect; old flow →
 * cache-busted /cart.js poll with the '"price":0' substring test. DIV-046
 * (issue #381) bounds that poll at OLD_FLOW_POLL_MAX_ATTEMPTS (was UNBOUNDED,
 * §8.4 — count was incremented but never consulted) and, on hitting that
 * bound or a fetch error, shows a "check your cart" error instead of giving
 * up silently with the loader left stuck visible. This poll only ever runs
 * after /cart/add already succeeded, so its error (unlike submit-form-data's)
 * must not claim the add itself failed — see CART_CONFIRMATION_FAILED_MESSAGE.
 */
import { appState } from "../state/app-state";
import $ from "jquery";
import { CART_CONFIRMATION_FAILED_MESSAGE, showAddToCartError } from "./add-to-cart-error";

const OLD_FLOW_POLL_MAX_ATTEMPTS = 15;

export function IsShopifyCartReady(count = 0): void {
  if (appState.cpc_waitforcartconfirmation === false) {
    // New flow, no cart drawer — redirect to /cart
    var finalCartUrl = PrepareCartRedirectUrl();
    window.location.href = finalCartUrl;
    $(".loading-anim-cpc").hide();
  } else if (count >= OLD_FLOW_POLL_MAX_ATTEMPTS) {
    // The add itself already succeeded (this poll only runs after a
    // successful /cart/add) — tell the shopper to check their cart, not
    // that nothing was added.
    console.log("CPC: cart confirmation poll gave up after " + OLD_FLOW_POLL_MAX_ATTEMPTS + " tries");
    showAddToCartError(CART_CONFIRMATION_FAILED_MESSAGE);
  } else {
    // Old flow — poll /cart.js until price is confirmed, then redirect to /cart
    fetch("/cart.js?cache=false&q=" + Math.random())
      .then((response) => response.json())
      .then(function (response) {
        var cartDataAsString = JSON.stringify(response);
        var zeroPriceIndex = cartDataAsString.search('"price":0');
        if (zeroPriceIndex === -1) {
          var finalCartUrl = PrepareCartRedirectUrl();
          window.location.href = finalCartUrl;
          $(".loading-anim-cpc").hide();
        } else {
          count++;
          setTimeout(() => {
            console.log("waiting for cart confirmation");
            IsShopifyCartReady(count);
          }, 1000);
        }
      })
      .catch(function (error) {
        console.log(error);
        showAddToCartError(CART_CONFIRMATION_FAILED_MESSAGE);
      });
  }
}

/** First path segment of length 2-5 → treated as a locale prefix (REQ-CHK-8). */
export function PrepareCartRedirectUrl(): string {
  const url = new URL(window.location.href);
  const pathSegments = url.pathname.split("/").filter(Boolean);

  let redirectUrl;
  if (pathSegments.length > 0 && pathSegments[0]!.length >= 2 && pathSegments[0]!.length <= 5) {
    redirectUrl = `/${pathSegments[0]}/cart`;
  } else {
    redirectUrl = `/cart`;
  }

  return `${url.origin}${redirectUrl}`;
}
